var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 321.7 321.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#322144}.st3{fill:#4b3f56}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.2 107.4l-12.7-53 6-3s36.9 8 66.8-3.2l12.8 4.6-11.9 57.1-61-2.5z",
    fill: "#fa6b5b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.4 51.6l5.6 1.6.1-.3-12.8-4.6c-29.9 11.2-66.8 3.2-66.8 3.2l-6 3 .2.8c10.6 1.4 48.3 5.7 79.7-3.7z",
    fill: "#1d2251"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.8 121.7l-21.8.9s-2.3 4 3.9 10.2c6.3 6.3 34.8 20.2 35.4 17.4.6-2.7-2.2-12.5-4.6-14.9-2.3-2.3-12.9-13.6-12.9-13.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.1 122.7s34.9 14.6 39.3 27.7l4.8-21.7 2.8-43.6-22.1-17.4-24.8 55z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.8 118.3c1.2 3.6-32.8 33.1-38.7 30.7 0 0 .3-6.1 2.4-12.8 2.2-6.6 25.2-18.4 36.3-17.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M230.5 62.4l25.3 55.9s-35.5 11.5-38.7 30.7l-3.9-19.5V94.2l17.3-31.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9 67.7s19.6 45.7 19.6 57.1c0 11.5-7.4 105.9-13.4 132.8 0 0 80.4 16.9 124.8 2.3 0 0-14.5-87.2-9.7-130.5.3-2.4 17.3-67 17.3-67l-38.9-14.1s-8.9 33.2-35.5 33.2c-21.3 0-32.5-29.7-32.5-29.7L91.9 67.7z",
    fill: "#fa835b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 196.6c3.8-15.8 40.7-9.7 13.7-36.7-22.3-22.3-23.8-80.8-23.7-100.5l-16.6 8.3s19.6 45.7 19.6 57.1c0 11.5-7.4 105.9-13.4 132.8 0 0 28.1 5.9 60.2 7.7 1-7.5.4-16.4-5.1-24-12.5-16.9-38.5-28.9-34.7-44.7z",
    opacity: 0.54,
    fill: "#e06d48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.5 86.1c19.6 0 33.1-23.8 38.8-36.4l-4.1-1.5s-9 32-35.6 32c-21.3 0-31.2-28.8-31.2-28.8l-4.5 2.2c6.9 11.7 21.3 32.5 36.6 32.5z",
    fill: "#403160"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.25b04881f60a99717b8081666a3797d7.svg";
export { ForwardRef as ReactComponent };